<script>
    export let size = 30;
    export let inline = false;
    export let padding = '0';
    export let cssClass = '';
    export let color = '#888';
    export let loading = false;
</script>

{#if loading}
    <div class="loader-overlay {cssClass}" class:inline={inline}>
            <svg version="1.1" id="L2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px"
                 y="0px"
                 viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve" style="width:{size}px;height:{size}px;">
<circle fill="none" stroke="{color}" stroke-width="4" stroke-miterlimit="10" cx="50" cy="50" r="48"/>
                <line fill="none" stroke-linecap="round" stroke="{color}" stroke-width="4" stroke-miterlimit="10" x1="50"
                      y1="50" x2="85" y2="50.5">
  <animateTransform
          attributeName="transform"
          dur="2s"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"/>
</line>
                <line fill="none" stroke-linecap="round" stroke="{color}" stroke-width="4" stroke-miterlimit="10" x1="50"
                      y1="50" x2="49.5" y2="74">
  <animateTransform
          attributeName="transform"
          dur="15s"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"/>
</line>
</svg>
    </div>
{/if}
<style>
    .loader-overlay {
        text-align: center;
    }
    .loader-overlay.inline {
        display: inline-block;
    }

    .loader-box {
        display: inline-block;
        background: #fff;
        border-radius: 50%;
    }
</style>